<div class="position-absolute translate-middle bg-white d-flex flex-column justify-content-center py-4 px-3 rounded shadow pos-right-top">
  <header>
    <div class="d-flex align-items-center gap-3 mb-4 mt-2">
      <img src="assets/exportar-arquivos/file-arrow-down.svg" alt="Ícone de exportação" style="width: 3rem;">
      <div>
        <h3 class="h5 m-0"> {{ 'COMPONENTS.MAPA.EXPORT.title' | transloco }} </h3>
        <p class="mb-0 text-muted"> {{ 'COMPONENTS.MAPA.EXPORT.subtitle' | transloco }} </p>
      </div>
    </div>
  </header>

  <div class="d-flex flex-column justify-content-center align-items-center">
    <fieldset class="w-100">
      <ul class="list-unstyled d-flex flex-column align-items-center justify-content-between gap-4">
        <li><app-data-picker-padrao [width]="17" (eventoDatepicker)="pegarDados($event, 'dataPicker')"></app-data-picker-padrao></li>
        <li><app-select-padrao [width]="17" [dadosSelect]="listaClientes" [label]="'COMPONENTS.MAPA.EXPORT.client_label' | transloco" alt="data" imgSrc="assets/mapa/filtros/usuario.png" (eventoSelect)="pegarDadosCliente($event, 'clienteId')"></app-select-padrao></li>
        <li><app-select-padrao [width]="17" [dadosSelect]="listaOperacoes" [label]="'COMPONENTS.MAPA.EXPORT.operation_label' | transloco" alt="data" imgSrc="assets/mapa/filtros/operacao.png" (eventoSelect)="pegarDadosOperacao($event, 'operacaoId')"></app-select-padrao></li>
        <li><app-select-padrao [width]="17" [dadosSelect]="listaTipoMapas" [label]="'COMPONENTS.MAPA.EXPORT.type_label' | transloco" alt="data" imgSrc="assets/mapa/select/tipos-mapa.svg" (eventoSelect)="pegarDados($event, 'tipoMapa')"></app-select-padrao></li>
      </ul>
    </fieldset>

    <footer class="mt-2">
      <button [disabled]="!podeSubmeterFormulario" (click)="onSubmit()" class="btn text-white fw-semibold rounded-pill" style="background-color: var(--verde-premoplan);">
        {{ 'COMPONENTS.MAPA.EXPORT.submit_button' | transloco }}
      </button>
    </footer>
  </div>
</div>
